module.exports = __webpack_public_path__ + "img/dry_clean.48683c28.svg";